import axios from "axios";
import { addAlert, removeAlert } from "src/store/reducers/globalData";
import { store } from "../store";

export const alert = (text, type = "error") => {
  const id = Date.now();
  store.dispatch(addAlert({ id, type, text }));

  setTimeout(() => {
    store.dispatch(removeAlert(id));
  }, 2000);
};
